export enum SharedActions {
  GET_PERMISSION_TYPES = '[SHARED] Get Permission Types',
  GET_PERMISSION_TYPES_SUCCESS = '[SHARED] Get Permission Types Success',
}
